import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import GoogleButton from "../auth/GoogleAuth";
import { config } from "../config/config";
import "./LeftPanel.css";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebase";
const LeftPanel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleBuyPremiumClick = () => {
    logEvent(analytics, "leftpanel_buy_premium_click");

    navigate("/premium");
  };

  const handleNavLinkClick = (label) => {
    logEvent(analytics, "leftpanel_navlink_click", {
      link_label: label,
    });
  };

  return (
    <div className="left_panel">
      <div className="left_panel_logo_title">
        <img src={config.logo} alt="Logo" className="left_panel_logo" />
        <h1 className="left_panel_title">{config.title}</h1>
      </div>

      <button className="left_panel_buypremium" onClick={handleBuyPremiumClick}>
        <img src={config.crown} alt="Crown" className="left_panel_crown" />3
        Days Free Trial
      </button>

      <div className="btn-scroll">
         <NavLink
      className={`scroll_btn ${isActive("/") ? "active" : ""}`}
      onClick={() => handleNavLinkClick("Home")}
      to="/" // Make sure this is added
    >
      <span>
        <img src={config.homelp} alt="Home" className="scroll-img" />
      </span>
      Home
    </NavLink>

        <NavLink
          to="/privacy"
          className={`scroll_btn ${isActive("/privacy") ? "active" : ""}`}
          onClick={() => handleNavLinkClick("Privacy Policy")}
        >
          <span>
            <img src={config.privacylp} alt="Privacy" className="scroll-img" />
          </span>
          Privacy Policy
        </NavLink>

        <NavLink
          to="/refundpolicy"
          className={`scroll_btn ${isActive("/refundpolicy") ? "active" : ""}`}
          onClick={() => handleNavLinkClick("Refund Policy")}
        >
          <span>
            <img src={config.refundimg} alt="Refund" className="scroll-img" />
          </span>
          Refund Policy
        </NavLink>

        <NavLink
          to="/terms&condition"
          className={`scroll_btn ${
            isActive("/terms&condition") ? "active" : ""
          }`}
          onClick={() => handleNavLinkClick("Terms & Condition")}
        >
          <span>
            <img src={config.termsimg} alt="Terms" className="scroll-img" />
          </span>
          Terms & Condition
        </NavLink>

        <NavLink
          to="/blog"
          className={`scroll_btn ${isActive("/blog") ? "active" : ""}`}
          onClick={() => handleNavLinkClick("Blog")}
        >
          <span>
            <img src={config.blogimg} alt="Blog" className="scroll-img" />
          </span>
          Blog
        </NavLink>
      </div>

      <GoogleButton id="login_left" />
    </div>
  );
};

export default LeftPanel;
